import { AnimationBaseController, IAnimationControllerConfiguration, Inject, SoundType } from "../../../../modules/@denishussar/html5-game-engine";
import { GameLogic } from "../../../Logic/GameLogic";
import { GameModel } from "../../../Models/GameModel";
import { scaleModal } from "../../../Utils/DialogScale";
import { AnimationContents } from "../../AnimationContents";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";

export interface ITutorialScreenControllerOptions {

}

export class TutorialScreenController extends AnimationBaseController {
    $model: GameModel

    constructor(
        @Inject private _gameModel: GameModel,
        @Inject private _options: ITutorialScreenControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('ChooseSkinScreenController');
    };

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.TUTORIAL_JSON,
            libraryName: "modal_FTUE",
            childControllers: {
                ButtonConfirm: {
                    instanceName: "btn_ok",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.startNewGame();
                            this._gameLogic.hideModal();
                            this._gameLogic.showTapToStart();
                        }
                    }

                },
            },
            modelWatch: {

            }
        }

    }

    onResize(width: number, height: number, scale: number) {
        scaleModal(this, width, height, scale * 1.4, 1047, 606);
    }

    onInitialize() {

        const style = {
            fill: '#2d949e',
            stroke: '#ffffff',
            strokeThickness: 8
        };
        this.setTextStyleByQuery('title', style);
    }

}